
<div class="footer-action">
  <div class="float-right">
    <button class="btn btn-primary" :disabled="!isReportSelected && !allReportFields.length" @click="exportReport">Run Report</button>
  </div>
</div>
